import { render } from "./LandSubdivisionPublicProjectPage.vue?vue&type=template&id=37fd5112&scoped=true&ts=true&lang=pug"
import script from "./LandSubdivisionPublicProjectPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandSubdivisionPublicProjectPage.vue?vue&type=script&lang=ts&setup=true"

import "./LandSubdivisionPublicProjectPage.vue?vue&type=style&index=0&id=37fd5112&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fd5112"]])

export default __exports__